import { useState, useEffect } from 'react'
import { getMUICache, getUrl, appendStyleSheet, getEndpoint, getSocialClassName, getImageUrl, fetchAnchorValue,GetIconsSprites } from "../../../common/utils";

import { CacheProvider } from '@emotion/react';
//import { FrontAwesomeIcon } from '@fortawesome/react-frontawesome';
import bcrypt from 'bcryptjs-react';
import './FooterTwoAmp.css';

FooterTwoAmp.version = 1000;
Object.defineProperty(FooterTwoAmp, 'name', {
    writable: true,
    value: 'FooterTwoAmp'
});

export function FooterTwoAmp(props: any) {
    const [menuItems, setMenuItems] = useState<any>([]);
    const [footerData, setFooterData] = useState<any>({});
    const cache = getMUICache();
    const { showAbout, showSocialIcons, copyRightText, showStaticPages, anchorLinksValue } = props;
    let styles = require("./FooterTwoAmp.css");
    appendStyleSheet("Footer", styles);

    const endpoint = getEndpoint(props, "MAIN");
    const footerMenuEndpoint = getEndpoint(props, "FOOTER_MENU_API");
    useEffect(() => {
        if (!endpoint.isSSR || !endpoint.SSRDataObj || !footerMenuEndpoint.isSSR || !footerMenuEndpoint.SSRDataObj) {
            fetchComponentData();
        }
    }, []);

    if (endpoint.isSSR && endpoint.SSRDataObj && (!footerData || !Object.keys(footerData).length)) {
        setFooterData(endpoint.SSRDataObj);
    }

    if (footerMenuEndpoint?.isSSR && footerMenuEndpoint?.SSRDataObj && footerMenuEndpoint?.SSRDataObj.length && (!menuItems || !menuItems.length)) {
        setMenuItems(footerMenuEndpoint.SSRDataObj);
    }

    const fetchComponentData = () => {
        const { ENDPOINTS } = props;

        let footerAPI = getUrl(props, 0, false, "MAIN", true, ENDPOINTS[0].queryParams.websiteId, ENDPOINTS[0].queryParams.clientId);
        let menuAPIurl = getUrl(props, 0, false, "FOOTER_MENU_API", true)
        let footerString = `?` + footerAPI.split("?")[1];
        footerString = bcrypt.hashSync(footerString, 6);
        const customHeaders = {
            'Content-Type': 'application/json',
            'p-nonce': footerString
        };

        let headerString_menuAPIurl = '?' + menuAPIurl.split("?")[1];
        headerString_menuAPIurl = bcrypt.hashSync(headerString_menuAPIurl, 6);
        const headers_menuAPIurl = { 'p-nonce': headerString_menuAPIurl };

        Promise.all([
            fetch(footerAPI, {
                method: 'GET',
                headers: customHeaders,
                credentials: "include",
            }).then((response) => response.json()),

            fetch(menuAPIurl, { headers: headers_menuAPIurl }).then((response) => response.json()),
        ])

            .then(([result1, result2]) => {
                // Handle the results individually
                setFooterData(result1);
                setMenuItems(result2);
            })
            .catch((error) => {
                // Handle errors here
                console.error('Error fetching data:', error);
            });
    }

    const renderStaticPages = () => {
        if (!footerData.staticPages) {
            return false;
        }

        let listItems = footerData.staticPages.map((val: any, i: any) => {
            return <li className="static-p-links ampThemetwoFooterLinks" key={i}><a href={val.sourcePath} target={fetchAnchorValue(anchorLinksValue, val.sourcePath)}>{val.name}</a></li>
        })

        return (<div className="col-md-12">
            <ul className="footer-bottom-menu ampThemetwoFooterMenu">{listItems}</ul>
        </div>
        )
    }

    const getMenuItems = () => {
        return <div className="colNoNeed">
            <div className='footer-main-menu ampThemetwoFooterMainMenu'>
                <div className='Commonfooterlinkwrap footerlinkwrap-1 ampThemetwoFooterLinkwrap1'>
                    <ul className='footer-menu footerMenu-top ampThemetwoFooterTop'>
                        {menuItems.map((val: any, i: any) => {
                            let morePath: string = val.path;
                            if (val.type === 2) {
                                morePath = '/tags/' + (val.tagpath !== undefined ? val.tagpath : '');
                            }
                            return <li className='nav-item ampThemetwoFooterNavItem' key={i}><a className='navlink' href={morePath} target={fetchAnchorValue(anchorLinksValue, morePath)}>{val.name}</a></li>
                        })
                        }
                    </ul>
                </div>
            </div>
        </div>
    }

    const renderSocialIcons = () => {
        if (!footerData.socialPlatformList) {
            return false;
        }

        let html = <div className="socialMediaWrap ampThemetwoFooterLogoWrapper">
            <ul className='footerSocialList ampThemetwoFooterSocialIconWrapper'>
                {footerData?.socialPlatformList.filter((item: any) => item.url.trim() !== '').map((val: any, i: any) => {
                    let iconType = getSocialClassName(val.name, 2);
                    return <li><a key={i} href={val.url} target="_blank" aria-label="social shares">
                        
                        {/* <FrontAwesomeIcon icon={iconType} /> */}
                        <div className={`sprite-icon ${iconType}`} style={{ backgroundImage: `url(${GetIconsSprites()})` }}/>
                        </a></li>
                })
                }
            </ul>
        </div>

        return html;
    }

    return (
        <div>
            <CacheProvider value={cache}>
                {/* <div className='fix-wrapper footercontainer'>
                    <div className='amp-container'> */}
                <div className='ampThemetwoFooterWrapper'>
                    <div className='tempdiv  ampThemetwoFooterContainerWrapper'>
                        <div className='footerLogoImageWrap ampThemetwoFooterLogoWrap'>
                            <a href='/' aria-label="footer-logo" target={fetchAnchorValue(anchorLinksValue, "/")}>{footerData.footerLogo && <img src={getImageUrl((footerData.footerLogo), "422424", 96, undefined, "", false, props.CONSTANTS)} className='footerlogoimage ampThemetwoFooterLogoImage' width="96" height="36" alt='footer-logo' />}</a>
                        </div>
                        <div className='footerTextWrap ampThemetwoFooterShortInfo'>
                            {showAbout && <p>{footerData && footerData?.aboutSiteContent}</p>}
                        </div>
                    </div>
                </div>
                <div className='footerLinksSectionWrap fix-wrapper'>
                    <div className='ampThemeTworow'>
                        <div className='col-md-9 col-xs-12'>
                            <div className='footerLinksMainWrap'>
                                <div className='footerLeftSectionLink'>
                                    <div className='footerLeftSectionHeading'>Section</div>
                                    {menuItems && getMenuItems()}

                                </div>

                                <div className='footerLeftSectionLink'>
                                    {showStaticPages && <div className='footerLeftSectionHeading'>Company</div>}
                                    {showStaticPages && renderStaticPages()}

                                </div>
                            </div>
                        </div>
                        <div className='col-md-3 col-xs-12'>
                            <div className='footerAdressWrapper'>
                                {showSocialIcons && <div className='footerAdressHeading'>Follow us</div>}
                                {showSocialIcons && renderSocialIcons()}
                                <div className='footerAdressHeading'>Contact</div>
                                <ul className='footerAdressMainWrap'>
                                    <li>
                                        <i className="fas fa-map-marker-alt icon"></i> <span>{footerData && footerData?.contactUs}</span>
                                    </li>
                                    <li>
                                        <a href={`mailto:${props.supportEmail}`} aria-label="Email">
                                            <i className="fas fa-envelope"></i> <span> {footerData && footerData?.supportEmail}</span>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                {/* {menuItems && getMenuItems()}
                        {showSocialIcons && renderSocialIcons()} */}

                {/* </div>
                </div> */}
                <div className='footer-bottom ampThemetwoFooterBottom'>
                    <div className='footercontainer ampThemetwoFooterContainer'>
                        {showStaticPages && renderStaticPages()}
                        <div className="col-md-12 p-0">
                            <p className="copyright ampThemetwoFooterCopyRight" aria-label="copyrights">
                                {copyRightText ? copyRightText : footerData.copyRightContent}
                            </p>
                        </div>
                    </div>
                </div>
            </CacheProvider>
        </div>
    )
}
